// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Loan products'" tab="true">
    <a class="sub-header__create-button btn btn-primary"
       command-access="CreateLoanType"
       ng-href="#!/admin/loan-products/types/create">
      Create new
    </a>
  </sub-header>

  <div>
    <dynamic-list
      columns="\$ctrl.columns"
      data="\$ctrl.loanProducts"
      sorting="\$ctrl.sorting"
    >
    </dynamic-list>

    <div ng-if="!\$ctrl.loanProducts || !\$ctrl.loanProducts.length"
         class="empty-message">
      <span>No loan products found.</span>
    </div>
  </div>

  <div class="buttons">
    <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/list/loan-product-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;